import { Select, Input, Button, DatePicker, message } from "antd";
import {
  PhoneOutlined,
  FieldTimeOutlined,
  FileTextOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { addDealActivityApi, createTasksApi, saveConversationApi, callFeedbackApi } from "../../../../apiservice/crm";
import { fetchLeads } from "../leadThunk";
import { useDispatch } from "react-redux";
import { formatDayjsToUtc } from "../../../../lib/functions";
import LeadStatusSelect from "./LeadStatusSelect";
import "../../crmSharedStyle.css";

const CallTab = ({ lead, deal, onAfterSubmit }) => {

const [callStatus, setCallStatus] = useState();
const [remarks, setRemarks] = useState("");
const [followUp, setFollowUp] = useState(null);
const [duration, setDuration] = useState("");
const [loading, setLoading] = useState(false);
// Explicit, user-controlled -- defaults to the lead's current status so
// logging a call without touching this never changes it. Replaces the old
// server-side auto-derivation from call_status that sales complained about.
const [leadStatusId, setLeadStatusId] = useState(lead?.status_id || null);

const dispatch = useDispatch();

useEffect(() => {
  setLeadStatusId(lead?.status_id || null);
}, [lead?.id, lead?.status_id]);

// const submit = async () => {
//   if (!callStatus) {
//     return message.warning("Select call status");
//   }

//   setLoading(true);

//   try {
//     // ✅ CASE 1: Deal exists → use deal activity
//     if (deal?.deal_id) {
//       await addDealActivityApi({
//         deal_id: deal.deal_id,
//         type: "call",
//         call_status: callStatus,
//         duration: duration ? Number(duration) : null,
//         text: remarks,
//         followUpDate: followUp
//           ? dayjs(followUp).format("YYYY-MM-DD HH:mm:ss")
//           : null,
//       });
//     }

//     // ✅ CASE 2: No deal → fallback to lead activity
//     else {
//       await saveConversationApi({
//         customer_id: lead.id,
//         text: `Call: ${callStatus}${
//           duration ? ` | ${duration}s` : ""
//         }${remarks ? ` | ${remarks}` : ""}`,
//       });

//       // 🔥 optional: create follow-up task for lead
//       if (followUp) {
//         await createTasksApi ({
//           lead_id: lead.id,
//           type: "followup",
//           due_date: dayjs(followUp).format("YYYY-MM-DD HH:mm:ss"),
//           remarks: `Follow-up (${callStatus})`,
//         });
//       }
//     }

//     message.success("Call feedback saved ✅");

//     setCallStatus(null);
//     setRemarks("");
//     setFollowUp(null);
//     setDuration("");

//   } catch (err) {
//     console.error(err);
//     message.error("Failed ❌");
//   } finally {
//     setLoading(false);
//   }
// };


const submit = async () => {
    if (!callStatus) {
      return message.warning("Select call status");
    }

    setLoading(true);

  try {
    // ✅ CASE 1: Deal exists → FULL CRM FLOW
    if (deal?.deal_id) {
      await addDealActivityApi({
        deal_id: deal.deal_id,
        type: "call",
        call_status: callStatus,
        duration: duration ? Number(duration) : null,
        text: remarks || null,
        followUpDate: followUp
          // ? dayjs(followUp).format("YYYY-MM-DD HH:mm:ss")
          ? formatDayjsToUtc(followUp)
          : null,
        status_id: leadStatusId || null,
      });
    }

    // ✅ CASE 2: No deal → USE YOUR NEW PROPER API
    else {
      await callFeedbackApi({
        lead_id: lead.id,
        call_status: callStatus,
        remarks: remarks || null
          // ? `Call: ${callStatus} | ${remarks}`
          // : `Call: ${callStatus}`
          ,
        duration: duration ? Number(duration) : null,
        follow_up_date: followUp
          // ? dayjs(followUp).format("YYYY-MM-DD HH:mm:ss")
          ? formatDayjsToUtc(followUp)
          : null,
        status_id: leadStatusId || null,
      });
    

    //  optional: create follow-up task for lead
    // We already allFeedbackApi above , so commenting this out to avoid duplicates
      // if (followUp) {
      //   await createTasksApi ({
      //     lead_id: lead.id,
      //     type: "followup",
      //     due_date: dayjs(followUp).format("YYYY-MM-DD HH:mm:ss"),
      //     remarks: `Follow-up (${callStatus})`,
      //   });
      // }
    }

      message.success("Call feedback saved ✅");

    setCallStatus(null);
    setRemarks("");
    setFollowUp(null);
    setDuration("");
    dispatch(fetchLeads());
    onAfterSubmit?.(); 

  } catch (err) {
    console.error(err);
    message.error("Failed ❌");
  } finally {
    setLoading(false);
  }
};


return (
  <div style={{ maxWidth: 500 }}>
    {!deal && (
      <div className="crm-selected-chip" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
        <InfoCircleOutlined style={{ color: "#d48806" }} />
        No deal yet — call will be saved under lead activity
      </div>
    )}

    <div className="crm-form-section">
      <div className="crm-field-label">
        <TagsOutlined />
        Lead status
      </div>
      <LeadStatusSelect value={leadStatusId} onChange={setLeadStatusId} placeholder="Lead status" />
      <div style={{ fontSize: 12, color: "#8c8c8c", marginTop: 4 }}>
        Defaults to the lead's current status — change it here if this call should move the lead. Logging a call never changes the status on its own.
      </div>
    </div>

    <div className="crm-form-section">
      <div className="crm-field-label">
        <PhoneOutlined />
        Call status
      </div>
      <Select
        placeholder="Call Status"
        value={callStatus}
        onChange={setCallStatus}
        style={{ width: "100%" }}
        options={[
          { label: "Connected", value: "connected" },
          { label: "No Answer", value: "no_answer" },
          { label: "Missed", value: "missed" },
        ]}
      />
    </div>

    <div className="crm-form-section">
      <div className="crm-field-label">
        <FieldTimeOutlined />
        Duration (seconds)
      </div>
      <Input
        placeholder="Call duration in seconds"
        type="number"
        value={duration}
        onChange={(e) => setDuration(e.target.value)}
      />
    </div>

    <div className="crm-form-section">
      <div className="crm-field-label">
        <FileTextOutlined />
        Notes / feedback
      </div>
      <Input.TextArea
        className="crm-user-text"
        placeholder="Call notes / feedback"
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        autoSize={{ minRows: 2, maxRows: 10 }}
      />
    </div>

    <div className="crm-form-section">
      <div className="crm-field-label">
        <CalendarOutlined />
        Follow-up (optional)
      </div>
      <DatePicker
        showTime
        style={{ width: "100%" }}
        placeholder="Follow-up date (optional)"
        value={followUp}
        onChange={setFollowUp}
      />
    </div>

    <Button type="primary" size="large" loading={loading} block onClick={submit}>
      Submit Call Feedback
    </Button>
  </div>
);
};

export default CallTab;
